var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcMoClose = function SvgIcMoClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.232 5.557c-.39.39-.39 1.025 0 1.415l5.006 5.016-5.031 5.04c-.39.39-.39 1.024 0 1.415l.348.35a.998.998 0 0 0 1.413 0L12 13.752l5.031 5.04a.998.998 0 0 0 1.413 0l.349-.35c.39-.39.39-1.025 0-1.415l-5.032-5.04 5.007-5.016c.39-.39.39-1.024 0-1.415l-.349-.35a.998.998 0 0 0-1.413 0L12 10.224 6.993 5.208a.998.998 0 0 0-1.413 0l-.348.349Z"
  })));
};
export default SvgIcMoClose;